<template>
  <div class="changw-pwd">
    <WorkbenchTitle title="修改密码"></WorkbenchTitle>
    <div class="change-box">
      <div class="change-line">
        <div class="change-label">手机号：</div>
        <div class="change-cont">{{ phone | hidePhone }}</div>
      </div>
      <div class="change-line">
        <div class="change-label">验证码：</div>
        <div class="change-cont">
          <div class="change-input_box">
            <input
              type="text"
              v-model="code"
              class="change-input short"
              placeholder="请输入验证码"
            />
            <div class="get-code" @click="clickCodeBtn">
              {{ isCounting ? timeCount + "s" : "获取验证码" }}
            </div>
          </div>
        </div>
      </div>
      <div class="change-line">
        <div class="change-label">新密码：</div>
        <div class="change-cont">
          <div class="change-input_box">
            <input
              type="password"
              v-model="newPwd"
              class="change-input"
              placeholder="请输入新密码"
            />
          </div>
        </div>
      </div>
      <div class="change-line">
        <div class="change-label">确认新密码：</div>
        <div class="change-cont">
          <div class="change-input_box">
            <input
              type="password"
              v-model="confirmPwd"
              class="change-input"
              placeholder="请输入确认密码"
            />
          </div>
        </div>
      </div>
      <div class="confirm-btn" @click="clickSubmit">确定</div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import codeMixin from "@/mixins/codeMixin";
import WorkbenchTitle from "@/components/WorkbenchTitle";
import { fetchSendSms, fetchUpdateUserInfo } from "@/api/user";
import { getToken } from "@/utils/auth";
export default {
  name: "ChangePassword",
  mixins: [codeMixin],
  computed: {
    ...mapState("user", ["phone", "role", "platform"]),
  },
  components: {
    WorkbenchTitle,
  },
  data() {
    return {
      code: "",
      newPwd: "",
      confirmPwd: "",
    };
  },
  mounted() {},
  methods: {
    initData() {
      this.code = "";
      this.newPwd = "";
      this.confirmPwd = "";
      this.isCounting = false;
      this.timeCount = this.countNum;
    },
    fetchSmsApi() {
      const { phone } = this;
      fetchSendSms({
        phone,
      });
    },
    clickSubmit() {
      const { code, newPwd, confirmPwd } = this;
      if (!code) {
        this.$message({
          message: "请输入验证码",
          type: "error",
        });
        return false;
      }
      if (!newPwd) {
        this.$message({
          message: "请输入新密码",
          type: "error",
        });
        return false;
      }
      if (!confirmPwd) {
        this.$message({
          message: "请输入确认新密码",
          type: "error",
        });
        return false;
      }
      if (newPwd !== confirmPwd) {
        this.$message({
          message: "两次密码不一致",
          type: "error",
        });
        return false;
      }
      const loadingInstance = this.$loading();
      fetchUpdateUserInfo({
        platform: this.platform,
        role: this.role,
        code: this.code,
        common_token: getToken(),
        password: this.confirmPwd,
      })
        .then((res) => {
          const { code, msg } = res;
          if (code === 0) {
            this.initData();
            this.$message({ message: "密码修改成功", type: "success" });
          } else {
            this.$message({ message: msg, type: "error" });
          }
        })
        .finally(() => {
          loadingInstance.close();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
